import { useEffect } from "react";

export const browserBrandTitle = "SRR360 | Silk Road Retail";

/** Presentation metadata only: no navigation, auth, or data writes. */
export default function useBrowserTitle(authenticated: boolean, pageLabel: string) {
  useEffect(() => {
    document.title = authenticated ? `${pageLabel} | SRR360` : browserBrandTitle;
  }, [authenticated, pageLabel]);
}
